import { render, staticRenderFns } from "./BaseBackGroundCover.vue?vue&type=template&id=163baafa&scoped=true"
import script from "./BaseBackGroundCover.vue?vue&type=script&lang=js"
export * from "./BaseBackGroundCover.vue?vue&type=script&lang=js"
import style0 from "./BaseBackGroundCover.vue?vue&type=style&index=0&id=163baafa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163baafa",
  null
  
)

export default component.exports